import mortgagesApi from '@/api/MortgagesApi';

const state = {
  mortgageSimulations: undefined,
  mortgageFromCashflow: undefined,
  error: undefined,
};

const getters = {
  monthlyDiscountTotals: state => state.mortgageSimulations?.lowerMonthlyLowerTotal || state.mortgageSimulations?.lowerMonthlySameTotal,
  hasMortgageData: state => state.mortgageSimulations?.original,
  totalDiscountTotals: state => state.mortgageSimulations?.sameMonthlyLowerTotal,
  currentMortgageTotals: state => state.mortgageSimulations?.currentSimulation,
  mortgageFromCashflow: state => state.mortgageSimulations?.mortgageFromCashflow,
  hasMortgageAlternatives: state => {
    if (!state.mortgageSimulations) { return false; }
    return !state.mortgageSimulations.largeMonthlyCashflowDiff && !state.mortgageSimulations.multipleMortgagesExist
    && !!(state.mortgageSimulations.qualifiedForLowerMonthlySameTotalKpi
      || state.mortgageSimulations.qualifiedForSameMonthlyLowerTotalKpi);
  },
  hasIssueWithMortgageCalculation: state => {
    if (!state.mortgageSimulations) { return true; }
    return state.mortgageSimulations.largeMonthlyCashflowDiff || state.mortgageSimulations.multipleMortgagesExist;
  },
  createdAt: state => state.mortgageSimulations?.createdAt,
  reportGeneratedDate: state => state.mortgageSimulations?.reportGeneratedDate,
  mortgageSource: state => state.mortgageSimulations?.mortgageSource,
};

const actions = {
  async fetchMortgageSimulations({ commit }) {
    const { simulations, mortgageFromCashflow } = await mortgagesApi.getMortgagesSimulations();
    commit('setMortgageSimulations', simulations);
    commit('setMortgageFromCashflow', mortgageFromCashflow);
  },
  async getOptimizedMortgage({ commit }, newMortgageParams) {
    try {
      commit('setError', null);
      const optimizedMortgage = await mortgagesApi.getOptimizedMortgageBy(newMortgageParams);
      return optimizedMortgage;
    } catch (error) {
      commit('setError', error);
      return null;
    }
  },
};

const mutations = {
  setMortgageSimulations(state, simulations) {
    state.mortgageSimulations = simulations;
  },
  setMortgageFromCashflow(state, mortgageFromCashflow) {
    state.mortgageFromCashflow = mortgageFromCashflow;
  },
  setError(state, error) {
    state.error = error;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
